import { useMemo } from "react";
import { Badge, Button } from "reactstrap";
import _ from "underscore";
import ReadableFilter from "components/CRM/ReadableFilter";
import Droppable from "components/Dnd/Droppable";
import Draggable from "components/Dnd/Draggable";
import { ActionsRow } from "./ActionsRow";
import { CreateButton, WorkflowLine } from "./WorkflowElements";
import { Col, Row } from "reactstrap/es";
import AppTooltip from "elements/AppTooltip";

const TitleRow = ({ errors, action }) => {
  errors = errors?.[action?.id];

  const TheTitleRow = (
    <div
      className={`w-100 px-4 pt-4 pb-3 rounded-top ${
        errors ? "" : "border-superlight border-bottom"
      }`}
      style={{
        backgroundColor: errors ? "#ffa8a8" : undefined,
        border: errors ? "2px solid var(--danger)" : "",
      }}
    >
      <Row className="align-items-center">
        <Col xs="auto" className="pl-2">
          <div
            className={`border border-superlight px-2 rounded-sm bg-white`}
            style={{ position: "relative" }}
          >
            {action?.VectorIcon ? (
              <>
                <div
                  style={{
                    width: "calc(55px - 1rem)",
                    height: "calc(55px)",
                  }}
                  className="d-flex align-items-center"
                >
                  <img
                    src={action?.Icon}
                    style={{
                      width: "100%",
                    }}
                    alt="ICON"
                  ></img>
                </div>
              </>
            ) : (
              <i className={action.Icon} style={{ fontSize: 36 }} />
            )}
          </div>
        </Col>
        <Col xs="" className="pl-0">
          <div className="">
            <h3 className="font-weight-600 mb-0">{action.Name}</h3>
            <p className="m-0" style={{ fontSize: 14 }}>
              {action.Description}
            </p>
          </div>
        </Col>
      </Row>
    </div>
  );

  return errors ? (
    <AppTooltip content={errors} useTooltip>
      {TheTitleRow}
    </AppTooltip>
  ) : (
    TheTitleRow
  );
};

const IfElseWorkflowCard = ({
  action,
  actions,
  errors,
  openCreateDrawer,
  openEditDrawer,
}) => {
  const moduleAPIName = useMemo(() => {
    if (!action?.ReferencedAction) return undefined;

    const referencedAction = _.findWhere(actions, {
      id: action.ReferencedAction,
    });

    return referencedAction?.ModuleAPIName;
  }, [action?.ReferencedAction, actions]);

  return (
    <>
      <Draggable
        data={{ action }}
        id={action.id}
        useDragHandle
        disableTransform
        childComponent={(dragInfo, dragHandle) => (
          <div
            className="rounded workflow-if-else-card d-flex shadow-sm shadow--hover flex-column align-items-center"
            style={{
              width: "100%",
              maxWidth: 900,
              position: "relative",
              border:
                dragInfo.isOver && !dragInfo.isOverSame
                  ? "1px solid var(--dropdown-selected-dark)"
                  : "1px solid var(--superlight)",
              backgroundColor: dragInfo.isDragging
                ? "var(--superlight)"
                : dragInfo.isOver && !dragInfo.isOverSame
                ? "var(--dropdown-selected)"
                : "white",
              transition: "background-color 0.3s ease, outline 0.3s ease",
            }}
          >
            <div
              className="if-else-drag-handle"
              {...dragHandle.listeners}
              {...dragHandle.attributes}
            >
              <i
                className="mdi mdi-drag"
                style={{
                  fontSize: 24,
                }}
              />
            </div>
            <Badge
              style={{
                position: "absolute",
                padding: "4px 7px 3px 7px",
                fontSize: 15,
                top: -10,
                left: -10,

                cursor: "pointer",
                borderRadius: 8,
              }}
              className="px-2 cursor-pointer py-1 text-dark bg-primary-selected border border-primary"
            >
              {action?.Index}
            </Badge>

            <Button
              outline
              size="sm"
              className="edit-button"
              onClick={openEditDrawer}
            >
              Edit
            </Button>
            <TitleRow errors={errors} action={action} />
            <div className="p-3 w-100 border-bottom border-superlight">
              <h4 className="text-dark mb-2">Evaluation:</h4>
              <ReadableFilter
                query={action?.Evaluation}
                moduleAPIName={moduleAPIName}
                fallbackMessage={"No Condition(s) Added."}
              />
            </div>
            <div className="p-3">
              <Row className="align-items-top">
                <Col xs="6">
                  <Droppable
                    id={"Left" + action.id}
                    data={{ action }}
                    disabled={dragInfo.isDragging}
                    childComponent={() => (
                      <ActionsRow
                        title="IF TRUE"
                        type="True"
                        actions={action?.TrueActions}
                        parentID={action?.id}
                        childCard={true}
                        index={action.Index}
                        openCreateDrawer={openCreateDrawer}
                        openEditDrawer={openEditDrawer}
                        CreateButton={CreateButtonWrapper}
                        disableDnd={dragInfo.isDragging}
                        errors={errors}
                      />
                    )}
                  />
                </Col>
                <Col xs="6">
                  <Droppable
                    id={"Right" + action.id}
                    data={{ action }}
                    disabled={dragInfo.isDragging}
                    childComponent={() => (
                      <ActionsRow
                        childCard={true}
                        title="IF FALSE"
                        type="False"
                        actions={action?.FalseActions}
                        parentID={action?.id}
                        index={action.Index}
                        openCreateDrawer={openCreateDrawer}
                        openEditDrawer={openEditDrawer}
                        CreateButton={CreateButtonWrapper}
                        disableDnd={dragInfo.isDragging}
                        errors={errors}
                      />
                    )}
                  />
                </Col>
              </Row>
            </div>
          </div>
        )}
      />
      <WorkflowLine />
    </>
  );

  function CreateButtonWrapper({ actionID, actionType }) {
    return (
      <CreateButton onClick={() => openCreateDrawer(actionID, actionType)} />
    );
  }
};

export default IfElseWorkflowCard;
